module.exports = __webpack_public_path__ + "media/images/join-2-e339430f26a432d125f59c2dd05a981d.jpg";